import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SceneObject } from '../../../../models/session.model';

@Component({
  selector: 'app-session-scene-hierarchy-panel',
  standalone: true,
  imports: [CommonModule, FormsModule],
  host: {
    class: 'flex-1 flex flex-col min-h-0 overflow-hidden'
  },
  template: `
    <div class="flex-1 overflow-hidden p-4 flex flex-col min-h-0 h-full">
      <input type="text" placeholder="Buscar objeto..." [(ngModel)]="searchQuery" 
             class="w-full bg-black/30 border border-zaxis-border rounded-none px-3 py-2 text-sm text-white focus:outline-none focus:border-zaxis-accent mb-4 flex-shrink-0">
      
      <div class="flex-1 overflow-y-auto space-y-2 custom-scrollbar pr-2 min-h-0">
        <div *ngFor="let obj of getFilteredObjects()" 
             (click)="onFocusObject(obj.name)"
             class="p-3 bg-white/5 border border-zaxis-border hover:border-zaxis-accent/50 rounded-none cursor-pointer transition-colors group">
          <div class="flex justify-between items-center mb-1 gap-2">
            <span class="font-mono font-bold tracking-widest text-white uppercase text-sm group-hover:text-zaxis-accent transition-colors truncate">{{ obj.name }}</span>
            <span *ngIf="obj.isInteractable" class="px-1.5 py-0.5 bg-green-500/20 text-green-400 text-[9px] rounded-none uppercase font-bold whitespace-nowrap flex-shrink-0">Interactable</span>
          </div>
          <div class="flex flex-col gap-2 mt-2" *ngIf="objectStats[obj.name]">
            <div class="w-full space-y-1">
              <div class="flex justify-between text-[9px] text-gray-400 font-bold uppercase tracking-wider">
                <span>Atención</span>
                <span class="text-white">{{ objectStats[obj.name].hitPercentage | number:'1.1-1' }}%</span>
              </div>
              <div class="w-full h-1 bg-black rounded-none overflow-hidden">
                <div class="h-full bg-zaxis-accent" [style.width.%]="objectStats[obj.name].hitPercentage || 0"></div>
              </div>
            </div>
            <div class="w-full space-y-1" *ngIf="obj.isInteractable">
              <div class="flex justify-between text-[9px] text-gray-400 font-bold uppercase tracking-wider">
                <span>Interacciones</span>
                <span class="text-white">{{ objectStats[obj.name].interactionPercentage | number:'1.1-1' }}%</span>
              </div>
              <div class="w-full h-1 bg-black rounded-none overflow-hidden">
                <div class="h-full bg-purple-500" [style.width.%]="objectStats[obj.name].interactionPercentage || 0"></div>
              </div>
            </div>
            <div class="mt-2 w-full flex justify-end gap-2">
              <button (click)="$event.stopPropagation(); onLinkModel(obj)" class="text-[9px] px-2 py-1 bg-transparent border border-zaxis-border hover:bg-white/5 text-xs font-mono uppercase tracking-widest rounded-none text-gray-300 transition-colors font-bold">
                <i class="ph ph-link mr-1"></i> URL
              </button>
              <button (click)="$event.stopPropagation(); fileInput.click()" [disabled]="uploadingModel[obj.name]" class="text-[9px] px-2 py-1 bg-zaxis-accent/20 hover:bg-zaxis-accent/40 rounded-none text-zaxis-accent transition-colors uppercase font-bold tracking-wider flex items-center">
                <i class="ph" [ngClass]="uploadingModel[obj.name] ? 'ph-spinner animate-spin' : 'ph-upload-simple'"></i> 
                <span class="ml-1">{{ uploadingModel[obj.name] ? 'Subiendo...' : 'Subir Archivo' }}</span>
              </button>
              <input type="file" #fileInput class="hidden" accept=".glb,.gltf,.fbx,.ply,.las,.laz" (change)="onUploadModel(obj, $event)" />
            </div>
          </div>
        </div>
        
        <div *ngIf="getFilteredObjects().length === 0" class="text-center py-8 text-gray-500 text-sm">
          No se encontraron objetos con ese nombre.
        </div>
      </div>
    </div>
  `
})
export class SessionSceneHierarchyPanelComponent {
  @Input() objects: SceneObject[] = [];
  @Input() objectStats: Record<string, any> = {};
  @Input() uploadingModel: Record<string, boolean> = {};

  @Output() focusObject = new EventEmitter<string>();
  @Output() linkModel = new EventEmitter<SceneObject>();
  @Output() uploadModel = new EventEmitter<{obj: SceneObject, file: File}>();

  searchQuery: string = '';

  getFilteredObjects(): SceneObject[] {
    if (!this.objects) return [];
    if (!this.searchQuery.trim()) return this.objects;
    const q = this.searchQuery.toLowerCase();
    return this.objects.filter(o => o.name.toLowerCase().includes(q));
  }

  onFocusObject(name: string) {
    this.focusObject.emit(name);
  }

  onLinkModel(obj: SceneObject) {
    this.linkModel.emit(obj);
  }

  onUploadModel(obj: SceneObject, event: any) {
    const file = event.target.files?.[0];
    if (file) {
      this.uploadModel.emit({ obj, file });
    }
    event.target.value = '';
  }
}
